import { service } from '../api/axios';

export const putSettings = async (settings: Object) => {
  await service
    .put(`/notificationSettings`, settings)
    .then((responseFromAPI) => responseFromAPI.data);
};
